import { render } from "./RoleAdd.vue?vue&type=template&id=0fb8f1dc&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"

import "./RoleAdd.vue?vue&type=style&index=0&id=0fb8f1dc&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb8f1dc"]])

export default __exports__